export default "__VITE_ASSET__CEdbyVJt__"